// REACT & REDUX
import React, { Component } from "react";

// STYLE, PROPS & TRANSLATIONS
import "../../style/site.css";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

// COMMON

// COMPONENTS
import Paper from "@material-ui/core/Paper";
import { Typography, Grid, GridItem, SpacerContainer } from "careconnect-ui";

// CONTAINERS

// ACTIONS & API

// *************************************************************************************************************************************

const styles = theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper
    },
    paper: {
        minHeight: 850
    }
});

class Home extends Component {
    render() {
        const { classes } = this.props;

       return (
            <div className={classes.root}>
                <Paper className={classes.paper}>
                    <Grid>
                        <GridItem xs={12}>
                            <SpacerContainer left="medium" right="medium">
                                <Typography variant="h2">Bienvenue sur upload certificat</Typography>
                            </SpacerContainer>
                        </GridItem>
                    </Grid>
                </Paper>
            </div>
        );
    }
}

Home.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(Home);
